import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setDone(true);
    } catch (err) {
      toast.error("Could not process request");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-xs font-mono-tech tracking-[0.25em] text-[#FF5100] mb-2">
        SUPPLIERS · RECOVERY
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-none mb-6 text-neutral-900">
        Forgot your password?
      </h1>

      {!done ? (
        <form onSubmit={submit} data-testid="forgot-form" className="border border-neutral-200 bg-neutral-50 p-6 space-y-4">
          <p className="text-sm text-neutral-600">
            Enter the email you registered with. We'll send a reset link valid for 1 hour.
          </p>
          <label className="block">
            <div className="text-[10px] uppercase tracking-[0.2em] font-mono-tech text-neutral-500 mb-1.5">Email</div>
            <input
              data-testid="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@workshop.co.za"
              className="w-full bg-white border border-neutral-200 focus:border-[#FF5100] outline-none px-3 h-11 text-sm"
            />
          </label>
          <button
            type="submit"
            data-testid="forgot-submit"
            disabled={busy}
            className="w-full px-6 h-11 bg-[#FF5100] hover:bg-[#E64A00] disabled:opacity-50 text-white font-bold uppercase tracking-wider text-xs transition-colors"
          >
            {busy ? "Sending..." : "Send reset link"}
          </button>
          <div className="text-center text-xs text-neutral-500 pt-2 border-t border-neutral-200">
            <Link to="/login" className="text-[#FF5100] hover:underline">Back to sign in</Link>
          </div>
        </form>
      ) : (
        <div data-testid="forgot-done" className="border border-emerald-200 bg-emerald-50 p-6 text-sm text-emerald-700">
          If that email is registered, a reset link is on its way. Check your inbox (and spam folder).
        </div>
      )}
    </div>
  );
}
